module.exports = __webpack_public_path__ + "static/media/man-holding-sandwhich.a17d934d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/man-holding-sandwhich.jpg
// module id = 1589
// module chunks = 0